<template>

    <div class="row h-100 justify-content-center align-items-center bg-info text-light">

        <div class="col-sm-8 col-11">

            <h1>Idea</h1>

            <div class="col-sm-8 col-11"> Muchas gracias. </div>

            <button class="btn w-100 btn-light btn-lg mt-4" @click="start"> Otra idea </button>

        </div>

    </div>

</template>

<script>
import { mapActions } from "vuex";
import router from "../router";
export default {
    methods: {
        start() {
            this.clearIdea();
            router.push({ name: "Idea1" });
        },
        ...mapActions(["clearIdea"]),
    },
};
</script>

